import JobAppEventMutations from "./jobAppEvent/jobAppEvent.mutation";
import JobAppEventQueries from "./jobAppEvent/jobAppEvent.query";

const JobAppEventServices = {
  ...JobAppEventQueries,
  ...JobAppEventMutations,
};

export default JobAppEventServices;
